import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ breakpoints } : Theme) => createStyles({
  title: {
    fontSize: 12,
    color: '#515B6A',
    marginBottom: 8,
  },
  subTitle: {
    fontSize: 16,
    marginBottom: 20,
  },
  button: {
    fontSize: 16,
    height: 32,
    textTransform: 'unset',
    width: 134,
    paddingTop: 2,
    paddingBottom: 2,
    color: '#018694',
    borderColor: '#018694',
    fontWeight: 700,

    '& +button': {
      marginLeft: 16,
    },
  },
  cancelButton: {
    color: '#F8221A',
    borderColor: '#F8221A',
  },
  controlPanel: {
    marginBottom: 50,
  },
  remainingCreditsWrapper: {
    marginTop: 54,
  },
  noDataTip: {
    fontSize: 16,
    fontFamily: 'Roboto',
    fontWeight: 500,
  },
}));

export default useStyles;
